<div class="in_vitro_fertilization header_top mb-5">
    <section class="treatment_banner">
        <div class="container">
            <div class="banner_content">
                <h6>IVF Treatment in <br> Kannur</h6>
                <h2 class="visually-hidden">In Vitro Fertilization in Kannur</h2>
                <p>Looking for the best IVF centre in Kannur with high success <br> rates? We offer affordable IVF
                    treatment in Kannur with <br>expert care and advanced technology to help you achieve pregnancy.
                </p>
                <button (click)="contactus()"> Book a Consultation</button>
            </div>
        </div>
    </section>
    <section class="how_does_work_ivf mt-5">
        <div class="container">
            <div class="row aic">

                <div class="col-lg-7 col-md-7 col-sm-12">
                    <h6>What is IVF and How Does It Work?</h6>
                    <p>In Vitro Fertilization (IVF) is an advanced fertility treatment that helps couples overcome
                        infertility and achieve pregnancy. It involves stimulating the ovaries, retrieving mature
                        eggs,
                        fertilizing them with sperm in a laboratory, and transferring a healthy embryo into the
                        uterus.
                    </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <img loading="lazy" src="../../assets/images/treatment/how_ivf.webp" alt="">
                </div>
            </div>
        </div>
    </section>
   
    <section class="how_does_ivf_process_work mt-5">
        <h4 class="title_header tac">
            How Does the IVF Process Work?
        </h4>
        <p class="title_para">
            We follow a structured, step-by-step approach to maximize your chances of a successful pregnancy
        </p>
        <div class="container">
            <div class="row">
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="1">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_1.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 1: Personalized Consultation & Fertility Testing
                    </h5>
                    <p>
                        A detailed assessment with blood tests, ultrasound scans, and semen analysis.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="2">
                    <h5>
                        Step 2: Ovarian Stimulation
                    </h5>
                    <p>
                        Fertility medications stimulate the ovaries to produce multiple eggs.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_2.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="3">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_3.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 3: Egg Retrieval (Ovum Pick-Up)
                    </h5>
                    <p>
                        A quick, minimally invasive procedure under mild sedation.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="4">
                    <h5>
                        Step 4: Sperm Collection & Fertilization
                    </h5>
                    <p>
                        Best-quality sperm is selected to fertilize the eggs in our advanced IVF lab.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_4.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="5">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_5.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 5: Embryo Development & Selection
                    </h5>
                    <p>
                        Fertilized embryos are monitored for 3-5 days to choose the healthiest for
                        transfer.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="6">
                    <h5>
                        Step 6: Embryo Transfer
                    </h5>
                    <p>
                        The selected embryo is gently placed into the uterus for implantation.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_6.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="7">
                    <img loading="lazy" src="../../../../assets/images/treatment/ivf/ivfop_7.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 7: Pregnancy Test & Follow-Up
                    </h5>
                    <p>
                        A pregnancy test is conducted after 12-14 days to confirm success.
                    </p>
                </div>
            </div>
        </div>

    </section>
    <section class="advance_icf_tech mt-5">
        <h4 class="title_header tac">
            Advanced IVF Techniques for Higher Success
        </h4>
        <p class="title_para">
            We follow a structured, step-by-step approach to maximize your chances of a successful pregnancy
        </p>
        <div class="container">
            <div class="ait_head">

                <div class="ait_content">
                    <h6>ICSI (Intracytoplasmic Sperm Injection)</h6>
                    <p>A breakthrough for male infertility, <br> injecting a single healthy sperm into the <br> egg.
                    </p>
                </div>
                <div class="ait_content">
                    <h6>Blastocyst Culture</h6>
                    <p>Extending embryo growth to day 5 for <br> higher implantation success.</p>
                </div>
                <div class="ait_content">
                    <h6>PGT (Preimplantation Genetic Testing)</h6>
                    <p>Screening embryos for genetic health <br>before transfer.</p>
                </div>
                <div class="ait_content">
                    <h6>Frozen Embryo Transfer (FET)</h6>
                    <p>Preserving high-quality embryos for <br> future attempts</p>
                </div>
                <div class="ait_content">
                    <h6>Donor Egg & Sperm Options</h6>
                    <p>Expanding possibilities for couples facing <br>egg or sperm-related challenges.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="pink_bg_content mt-5">
        <div class="container">
            <div class="pink_bg_content_child">
                <h5>How Much Does IVF Cost in Kannur?</h5>
                <p>Many couples worry about the cost of IVF. While pricing varies based on individual treatment
                    needs, our <br> team ensures affordable IVF options with flexible plans.</p>
                <button (click)="contactus()">Contact Us</button>
            </div>
        </div>
    </section>
    <section class="ivf_success_rate mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 cool-md-6 col-sm-12">
                    <h6><span>IVF Success Rates</span> <br> What to Expect</h6>
                </div>
                <div class="col-lg-6 cool-md-6 col-sm-12">
                    <p>IVF success depends on factors like age, egg quality, and sperm <br> health. At NCare IVF in
                        Kannur, we optimize your chances with <br>cutting-edge technology and personalized care.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="what_we_provide mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <img loading="lazy" src="../../assets/images/treatment/what_we_provide.webp" alt="">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h6>WHAT WE PROVIDE</h6>
                    <ul>
                        <li><span>Women under 35</span>– 50-60% success rate per cycle</li>
                        <li><span>Women aged 35-40</span> – 35-45% success rate per cycle</li>
                        <li><span>Women over 40</span>– 20-30% success rate per cycle</li>
                    </ul>
                    <p>With advanced embryo selection and customized treatment <br> protocols, we strive to achieve
                        the best possible outcomes for <br> every patient.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="meet_our_fertility_expert mt-5">
        <h4 class="title_header tac">
            Meet Our Fertility Experts – Your Trusted IVF Specialists
        </h4>
        <p class="title_para">
            At NCare IVF, we are committed to helping you achieve parenthood with the expertise of our top fertility
            <br>
            specialists, embryologists, and andrologists. With advanced technology and personalized treatment plans,
            we <br> ensure the highest chances of success.
        </p>
        <div class="container">

            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <img loading="lazy" src="../../assets/images/treatment/mofe_1.webp" alt="">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h6>Ms Soorya Gayathri N <br> (Director and Chief Embryologist)</h6>
                    <p>With over 9 years of experience in assisted reproduction, I specialize in advanced fertility
                        techniques like ICSI and PICSI to overcome male infertility. Our state-of-the-art IVF lab in
                        Kannur is designed to maximize precision, ensuring the best possible outcomes for every
                        couple.
                    </p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h6> Dr. Baiju P.A <br> (Clinical Director, Chief consultant in Reproductive endocrinology and
                        ART)</h6>
                    <p>Did you know that male factor infertility contributes to nearly 40-50% of infertility cases? At
                        NCare IVF, we utilize cutting-edge techniques like ICSI and PICSI to enhance fertilization
                        success, helping couples move one step closer to their dream of parenthood.</p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <img loading="lazy" src="../../assets/images/treatment/mofe_2.webp" alt="">
                </div>
            </div>
        </div>
    </section>

    <section class="why_choose_ncare_ivf_kannur mt-5">
        <div class="container">
            <h4 class="title_header tac">
                Why Choose NCare IVF in Kannur?
            </h4>
            <p class="title_para">
                Finding the right IVF treatment in Kannur is crucial for your fertility journey. At NCare IVF, we
                combine cutting-edge <br> technology, expert fertility care, and a supportive environment to maximize
                your
                chances of success.
            </p>
            <div class="row">
                <span></span>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_1.svg" alt="">
                        <h5>Top IVF Success Rates</h5>
                        <p>Advanced lab techniques and precise embryo selection.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_2.svg" alt="">
                        <h5>Expert Fertility Specialists</h5>
                        <p>Years of experience in reproductive medicine.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_3.svg" alt="">
                        <h5>Comprehensive IVF Services</h5>
                        <p>From consultation to post-treatment care.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_4.svg" alt="">
                        <h5>Patient-Centric Approach</h5>
                        <p>Personalized treatment for every couple.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_5.svg" alt="">
                        <h5>Ethical & Transparent Care</h5>
                        <p>No hidden costs, only trusted fertility solutions.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/ivf/wcnvk_6.svg" alt="">
                        <h5>Easily Accessible Location</h5>
                        <p>Premier IVF center in Kannur.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>